import React from "react";
import styles from "./index.module.scss";
import InvestorListingSkeleton from "../../../skeleton/inv-acc-skeleton";
import InvCard from "../inv-card";
import { useInvList } from "../../../hooks/react-query/inv-exchange/useInvList";
import InvWebCard from "../inv-web-card";

export default function InvestorListing() {
  const { data, isLoading } = useInvList();

  return (
    <div className={styles.investorListing}>
      {isLoading && <InvestorListingSkeleton />}
      {!isLoading && data?.length > 0
        ? data?.map((item: any, index: number) => (
            <div
              key={`inv-list-${index}-${item.accountName}`}
              className={styles.invListItemWrapper}
            >
              <InvCard
                propertySfid={item?.propertySfid}
                accountSfid={item?.accountSfid}
                createdAt={item.createdAt}
                address={item.address}
                checkoutId={item.checkoutId}
                propertyId={item.propertyId}
                accountId={item.accountId}
                accountName={item.accountName}
                expiryAt={item.expiryAt}
                releasedAt={item.releasedAt}
                email={item?.email}
                plainPhone={item?.plainPhone}
                bidCount={item?.bidCount}
                contacts={item?.contacts}
                // engmtStatus={item?.engmtStatus}
                portalStatus={item?.portalStatus}
              />
              <InvWebCard
                portalStatus={item?.portalStatus}
                propertySfid={item?.propertySfid}
                accountSfid={item?.accountSfid}
                bidCount={item?.bidCount}
                createdAt={item.createdAt}
                address={item.address}
                checkoutId={item.checkoutId}
                propertyId={item.propertyId}
                accountId={item.accountId}
                accountName={item.accountName}
                expiryAt={item.expiryAt}
                releasedAt={item.releasedAt}
                email={item?.email}
                plainPhone={item?.plainPhone}
                contacts={item?.contacts}
                // engmtStatus={item?.engmtStatus}
              />
            </div>
          ))
        : !isLoading && (
            <div className={styles.noDataFound}>
              <img src="/images/no-data-found.svg" alt="No Data" />
              <p>No investors found</p>
            </div>
          )}
    </div>
  );
}
